import React from 'react';

import './styles.scss';

const DPSceneHs = ({ data, onClickHotspot }) => {
  return (
    <div class="circle-container">
      <div class="circle" onClick={onClickHotspot}></div>
      {/* <div className="circle-content">
        <p>{data.title}</p>
      </div> */}
    </div>
  );
};

export default DPSceneHs;
